import {
  AbholzeitType,
  Terminart,
  Oeffnungszeiten,
  Oeffnungszeiten_Oeffnung as Oeffnung,
  RemoteResult,
  OeffnungRequest,
  BPLieferungTerminWaehlenRequest,
} from "mangdto"
import moment from "moment"
import store from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BaseLogic from "../base_logic"

export default class TerminLieferungLogic extends BaseLogic {
  selectedLieferType: AbholzeitType = AbholzeitType.Baldest
  private _selectedDate?: string = null
  selectedTime?: string = null
  selectedOeffnung: Oeffnung = null
  geoeffneteTage: Oeffnung[] = null
  minDate?: string = null
  maxDate?: string = null
  uhrzeiten = []

  insertWorking: boolean = false
  insertError: boolean = false

  editMode: boolean = false

  get selectedDate(): string {
    return this._selectedDate
  }

  get abholtypes() {
    if (!this.filiale) return null
    if (!this.filiale.zurZeitGeoeffnetLieferung) {
      return [{ label: "Termin wählen", value: AbholzeitType.Uhrzeit }]
    }
    return [
      { label: "Schnellstmöglich", value: AbholzeitType.Baldest },
      { label: "Termin wählen", value: AbholzeitType.Uhrzeit },
    ]
  }

  get weiterDisabled(): boolean {
    if (this.selectedLieferType == AbholzeitType.Baldest) return false
    if (this.selectedDate == null || this.selectedTime == null) return true
    return false
  }

  set selectedDate(value: string) {
    this._selectedDate = value

    let oeffnung = null

    this.geoeffneteTage.forEach((toCompare) => {
      if (toCompare.datum == value) {
        oeffnung = toCompare
        return
      }
    })
    this.selectedOeffnung = oeffnung

    var uz = []
    this.selectedOeffnung.oeffnungszeiten.forEach((oz) => {
      var vonTemp = moment(oz.zeitVon, "HH:mm:ss").clone()
      var bis = moment(oz.zeitBis, "HH:mm:ss")

      while (vonTemp.isBefore(bis)) {
        uz.push(vonTemp.clone())
        vonTemp.add(15, "minutes")
      }
    })
    this.uhrzeiten = uz.map((el) => {
      return el.format("HH:mm")
    })
  }

  terminBearbeiten() {
    this.editMode = true
  }

  terminAuswaehlen() {
    this.insertWorking = true
    this.insertError = false

    var request = new BPLieferungTerminWaehlenRequest()
    request.id = store.state.user.identifier
    request.type = this.selectedLieferType
    if (this.selectedLieferType == AbholzeitType.Uhrzeit) {
      request.zeitpunkt = this._selectedDate + "T" + this.selectedTime
    }

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingLieferungTermin,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.mainLogic.bestellungPending.lieferung.abholzeitType =
            this.selectedLieferType
          if (this.selectedLieferType == AbholzeitType.Uhrzeit) {
            this.mainLogic.bestellungPending.lieferung.gewaehlteUhrzeit =
              response.data.payload
          }

          router.push({
            name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE,
          })
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  weiter() {
    router.push({
      name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE,
    })
  }

  abholzeitType: string
  termin: string

  init() {
    this.abholzeitType =
      this.mainLogic.bestellungPending.lieferung.abholzeitType
    this.termin = this.mainLogic.bestellungPending.lieferung.gewaehlteUhrzeit

    if (this.abholzeitType != null) {
      this.editMode = false
    } else {
      this.editMode = true
    }

    if (!this.filiale.zurZeitGeoeffnetLieferung) {
      this.selectedLieferType = AbholzeitType.Uhrzeit
    }

    var filialeId = this.filiale.filialeId
    var request = new OeffnungRequest()
    request.filialeId = filialeId
    request.terminart = Terminart.Lieferung

    Poster.postUser<RemoteResult<Oeffnungszeiten>>(
      RestPaths.oeffnungszeitOeffnungszeitenLieferung,
      request,
    ).then((response) => {
      this.minDate = response.data.payload.minDate
      this.maxDate = response.data.payload.maxDate
      this.geoeffneteTage = response.data.payload.daten
    })
  }

  datumWaehlen() {}
}
